import { AfterViewInit, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TemplateManagerService } from 'src/app/services/template-manager.service';
import { SnackbarComponent } from '../../snackbar/snackbar.component';
import { OpenCaseTemplateComponent } from '../open-case-template/open-case-template.component';
import { Clipboard } from "@angular/cdk/clipboard"
import { FormControl } from '@angular/forms';
import { ShipmentMonitorService } from 'src/app/services/shipment-monitor.service';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-multiple-open-case-dialog',
  templateUrl: './multiple-open-case-dialog.component.html',
  styleUrls: ['./multiple-open-case-dialog.component.scss']
})
export class MultipleOpenCaseDialogComponent implements OnInit,AfterViewInit,OnDestroy{
  selectedRows:any[] = [];
  textAreaForm = new FormControl();
  selectedTemplate:any;
  templateText:string;
  storeTemplateVar:any[] = [];
  textArea: any;
  isEdit:boolean = false;
  multipleSelectedRows:any[] =[];
  loader:boolean = false;
  @ViewChild('textArea') _textArea: ElementRef;
  link = 'https://sellercentral.amazon.com/help/center';
  templates:any[]=[];
  private destroy$ = new Subject<void>();

  constructor( 
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<MultipleOpenCaseDialogComponent>,
    private TemplateManagerService:TemplateManagerService,
    private snackBar:MatSnackBar,
    private dialog:MatDialog,
    private clipboard: Clipboard,
    private shipmentMonitorService:ShipmentMonitorService,
    private router:Router
  ){}

  ngOnInit(): void {
    this.selectedRows = this.data.data;
    this.storeTemplateVar=this.TemplateManagerService.storeTemplateVar;
    this.getTemplate();
  }

  ngAfterViewInit(): void {
    this.textArea = this._textArea?.nativeElement as HTMLTextAreaElement;
   }

  getShipmentDiscrepancy(shipmentDiscrepancyId){
    this.shipmentMonitorService.getShipmentDiscrepancy(shipmentDiscrepancyId).
    subscribe((res)=>{
      if(res){
        this.multipleSelectedRows.push(res);
        this.loader = false
        this.setTemplateWithValue();   
      }
    })
  }

  action(event){
    this.close();
  }
 
  close(){
   this.dialogRef.close();
  }
  
  openOnAmazon(shipment) {
   window.open(
     `https://sellercentral.amazon.com/fba/inbound-shipment/summary/${shipment.amazonShipmentId}`,
     "_blank"
    );
  }

  getTemplate(){
    this.loader = true;
    this.TemplateManagerService.getTemplates().pipe(takeUntil(this.destroy$)).subscribe({
      next: (res:any) => {
      if(res){
        this.templates = res; 
        this.templates.forEach((res, i) => {
          if (res) {
            this.templates[i].templateText = this.TemplateManagerService.formatTempWithVarName(res.templateText);
          }
        }); 
        const defaultTemplate = res.filter((res) => res.isDefault);
        this.selectedTemplate = defaultTemplate.length ? defaultTemplate[0] : res[0];
        this.selectedTemplate.templateText = this.selectedTemplate.templateText.replace(/\n/g, '<br>')
        this.selectedRows.forEach((el)=>{
          if(el){
            this.getShipmentDiscrepancy(el.ShipmentDiscrepancyId);
          }
        })
      }
    },
     error: (err) => {
      this.snackBar.openFromComponent(SnackbarComponent, {
        duration: 4000,
        horizontalPosition: "center",
        data: {
          title: err.error?.error[0],
          action: "Dismiss",
          type: "error",
        },
      });
     }
   });
  }

  setTemplateWithValue(){
    this.multipleSelectedRows.forEach((el)=>{
      el['selectedText'] = this.TemplateManagerService.formatVarNameWithValues(el,this.selectedTemplate.templateText);
    })
  }

  deleteSku(index){
    this.multipleSelectedRows.splice(index,1);
  }

  openLink(item,index){
    this.clipboard.copy(item.selectedText);
    this.dialog.open(OpenCaseTemplateComponent, {
      width: "472px",
      data: {
        title:'Open Case',
        isCaseLink:true,
        params:item,
        actions: [
          { text: "Cancel"},
          { text: "Save"},
        ],
      },
    }).afterClosed().subscribe((res)=>{
      if(res){
        this.multipleSelectedRows.splice(index,1);
        if(!this.multipleSelectedRows?.length){
          this.dialogRef.close();
        }
      }
    })
    window.open(this.link);
  }

  selectTemplate(item) {
    this.textArea = this._textArea?.nativeElement as HTMLTextAreaElement;
    if(this.textArea?.value){
      var start = this.textArea.selectionStart;
      var end = this.textArea.selectionEnd;
      this.selectedTemplate.templateText = this.textArea?.value.substring(0, start) + '' + `[${item.name}]` + '' + this.textArea.value.substring(end);
      this.textAreaForm.setValue(this.selectedTemplate.templateText);
    }else{
      this.selectedTemplate.templateText = this.selectedTemplate.templateText + `[${item.name}]`,
      this.textAreaForm.setValue(this.selectedTemplate.templateText);
    }
    this.TemplateManagerService.setPosition(this.textArea,start,item);
  }

  getTemplateVariables(){
    this.TemplateManagerService.getTemplateVariables().pipe(takeUntil(this.destroy$)).subscribe({
     next: (res:any) => {
      if(res){
        this.storeTemplateVar = res;
        this.TemplateManagerService.storeTemplateVar=res;
      }
     },
     error: (err) => {
      this.snackBar.openFromComponent(SnackbarComponent, {
        duration: 4000,
        horizontalPosition: "center",
        data: {
          title: err?.error?.error[0],
          action: "Dismiss",
          type: "error",
        },
      });
     }
   });
  }

  edit(){
    this.isEdit = !this.isEdit;
    this.selectedTemplate.templateText = this.selectedTemplate.templateText.replace(/<br>/g, '\n')
    this.textAreaForm.setValue(this.selectedTemplate.templateText);
  }

  save(){
    this.selectedTemplate.templateText = this._textArea?.nativeElement?.value.replace(/\n/g, '<br>');
    this.setTemplateWithValue();
    this.isEdit = false;
  }

  onChange(event){
    let index = this.templates.findIndex((res)=> res.templateId == event.templateId);
    if(index !== -1){
      this.selectedTemplate = event;
    }
    this.textAreaForm.setValue(this.selectedTemplate.templateText);
  }

  navigate(){
    this.dialogRef.close();
    this.router.navigate(['/settings/system-settings']);
  }

  cancel(){
    this.isEdit = false;
    this.selectedTemplate.templateText = this.selectedTemplate.templateText.replace(/\n/g, '<br>')
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
  
}
